"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var GenericButton_1 = __importDefault(require("../../../common/GenericButton"));
var NavigateNextIcon_1 = __importDefault(require("../../../common/Icons/NavigateNextIcon"));
var NavigateBeforeIcon_1 = __importDefault(require("../../../common/Icons/NavigateBeforeIcon"));
var track_event_1 = __importDefault(require("../../../../utils/track-event"));
var neighboring_module_scss_1 = __importDefault(require("./neighboring.module.scss"));
var styled_components_1 = __importDefault(require("styled-components"));
var Neighboring = function (_a) {
    var previous = _a.previous, next = _a.next;
    return (react_1.default.createElement("div", { className: neighboring_module_scss_1.default.root },
        react_1.default.createElement("div", { className: neighboring_module_scss_1.default.left }, previous && previous.path && (react_1.default.createElement("a", { href: previous.path },
            react_1.default.createElement(StyledGenericButton, { onClick: track_event_1.default.bind(null, {
                    category: 'closeup',
                    action: 'click',
                    label: 'prev_page',
                }) },
                react_1.default.createElement(NavigateBeforeIcon_1.default, { className: neighboring_module_scss_1.default.icon }),
                react_1.default.createElement("div", { className: neighboring_module_scss_1.default.name }, previous.name))))),
        react_1.default.createElement("div", { className: neighboring_module_scss_1.default.right }, next && next.path && (react_1.default.createElement("a", { href: next.path },
            react_1.default.createElement(StyledGenericButton, { onClick: track_event_1.default.bind(null, {
                    category: 'closeup',
                    action: 'click',
                    label: 'next_page',
                }) },
                react_1.default.createElement("div", { className: neighboring_module_scss_1.default.name }, next.name),
                react_1.default.createElement(NavigateNextIcon_1.default, { className: neighboring_module_scss_1.default.icon })))))));
};
var StyledGenericButton = (0, styled_components_1.default)(GenericButton_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background-color: white;\n  color: #2a3133;\n  border: 1px solid #ebecec;\n  padding: 8px 16px;\n  max-width: 100%;\n  margin: 0;\n\n  &:hover {\n    color: #23527c;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  background-color: white;\n  color: #2a3133;\n  border: 1px solid #ebecec;\n  padding: 8px 16px;\n  max-width: 100%;\n  margin: 0;\n\n  &:hover {\n    color: #23527c;\n  }\n"])));
exports.default = Neighboring;
var templateObject_1;
